// extracted by mini-css-extract-plugin
module.exports = {"fullscreen":"BBHTML_fullscreen__3Nlnu","fullwindow":"BBHTML_fullwindow__3RKt4"};